'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdTimer10 = function MdTimer10(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm21.5 22v-4.2c0-1.8-0.2-3.1-0.8-4.1-0.4-0.9-1.2-1.2-2.3-1.2-0.5 0-1.1 0.1-1.4 0.2-1.6 0.9-1.8 2.7-1.8 5.2v4.1c0 1.1 0 1.9 0.1 2.6s0.5 1.2 0.7 1.7c0.5 0.8 1.1 1.2 2.4 1.2 1.2 0 1.9-0.4 2.3-1.2 0.2-0.5 0.5-1 0.6-1.7s0.2-1.5 0.2-2.6z m-9.6-3.6c0-5.1 1.6-8.6 6.5-8.6 2 0 3.7 0.7 4.6 1.9 1.2 1.5 1.8 3.8 1.8 6.7v3.2c0 5-1.6 8.6-6.4 8.6-4.9 0-6.5-3.6-6.5-8.6v-3.2z m22.2-1c-1.3 0-2.4 0.5-2.4 1.8 0 1.2 0.6 1.2 1.5 1.6 0.4 0.1 0.9 0.3 1.5 0.4 0.9 0.1 1.5 0.4 2.2 0.6s1.2 0.6 1.7 0.9 0.8 0.8 1 1.3 0.4 0.9 0.4 1.6c0 2.4-1.6 3.5-3.4 4.1-0.7 0.2-1.5 0.3-2.4 0.3-2.8 0-4.9-1.1-5.8-3-0.2-0.6-0.3-1.1-0.3-1.8h3.2c0 1.7 1.3 2.4 2.9 2.4 1.5 0 2.6-0.5 2.6-1.8 0-1.1-0.7-1.3-1.5-1.7-1-0.4-2.7-0.7-3.7-1-0.7-0.3-1.1-0.6-1.6-0.9-0.9-0.6-1.5-1.5-1.5-2.8 0-2.2 1.6-3.5 3.3-4.1 0.7-0.2 1.4-0.3 2.3-0.3 3.2 0 5.8 1.5 5.8 4.6h-3.3c0-0.9-0.6-1.7-1.4-1.9-0.3-0.1-0.8-0.3-1.1-0.3z m-34.1-4.5l7.9-2.9h0.5v20h-3.4v-16l-5 1.7v-2.8z' })
        )
    );
};

exports.default = MdTimer10;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/timer-10.js
// module id = 2867
// module chunks = 0